import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useWsMemberStore} from "@domains/settings/stores/workspace-member.store";

export const getWorkspaceMembersResolver = async (): Promise<void> => {

    const wsStore = useWorkspaceStore();
    const wsMemberStore = useWsMemberStore();
    const workspaceId = wsStore.getSelectedWorkspaceId;

    await wsMemberStore.loadWorkspaceMembers(workspaceId)

};
